import isEmpty from 'lodash/isEmpty'

const compareListUsers = (currentList = [], incomingData) => {
  let message = ''
  let color = 'default'
  let error = false
  let changes = {}
  const userExist = currentList.find(
    (current) => current.code.toLowerCase() === incomingData.code.toLowerCase()
  )
  if (userExist) {
    if (incomingData.email.toLowerCase() !== userExist.email.toLowerCase()) {
      const userExistByEmail = currentList.find(
        (current) =>
          current.code.toLowerCase() !== incomingData.code.toLowerCase() &&
          current.email.toLowerCase() === incomingData.email.toLowerCase()
      )
      if (userExistByEmail) {
        message = 'Code exist but email already used by other user'
        color = 'error'
        error = true
      }
    }

    if (!error) {
      let user = {}
      Object.keys(incomingData).forEach((key) => {
        if (incomingData[key]) {
          if (key === 'email') {
            if (incomingData[key].toLowerCase().trim() !== userExist[key].toLowerCase().trim()) {
              user[key] = incomingData[key]
            }
          } else if (JSON.stringify(incomingData[key]) !== JSON.stringify(userExist[key])) {
            user[key] = incomingData[key]
          }
        }
      })

      if (Object.keys(user).length > 0) {
        message = 'User to be updated'
        color = 'info'
        changes = user
      } else {
        message = 'User no changes to update'
        color = 'default'
      }
    }
  } else {
    const userExistByEmail = currentList.find(
      (current) =>
        current.code.toLowerCase() !== incomingData.code.toLowerCase() &&
        current.email.toLowerCase() === incomingData.email.toLowerCase()
    )
    if (userExistByEmail) {
      message = 'User cannot be create, email in use'
      error = true
      color = 'error'
    } else {
      message = 'User to be created'
      color = 'success'
    }
  }

  return { message, error, color, changes }
}

const compareListClasses = (currentList, incomingData, updateYearLevels = false, updateSubject = false) => {
  let message = ''
  let error = false
  let color = 'default'

  const classExist = currentList.find((current) => current.code === incomingData.code)
  if (classExist) {
    const oldStudents = classExist.students?.map((item) => String(item.code || item))
    const oldTeachers = classExist.teachers?.map((item) => String(item.code || item))

    const newStudents = incomingData.students?.map((item) => String(item.code || item))
    const newTeachers = incomingData.teachers?.map((item) => String(item.code || item))

    const compareField = (oldField = [], newField = []) => {
      const add = newField?.filter((item) => !oldField.includes(item)) || []
      const remove = oldField?.filter((item) => !newField.includes(item)) || []
      return { add, remove }
    }

    const students = compareField(oldStudents, newStudents)
    const teachers = compareField(oldTeachers, newTeachers)

    const update = {}
    let messages = []
    if (students?.add?.length > 0 || teachers?.add?.length > 0) {
      update.add = {}
      if (students?.add?.length > 0) {
        messages.push(`Added students`)
        update.add.students = students.add
      }
      if (teachers?.add?.length > 0) {
        messages.push(`Added teachers`)
        update.add.teachers = teachers.add
      }
    }

    if (students?.remove?.length > 0 || teachers?.remove?.length > 0) {
      update.remove = {}
      if (students?.remove?.length > 0) {
        messages.push(`Removed students`)
        update.remove.students = students.remove
      }
      if (teachers?.remove?.length > 0) {
        messages.push(`Removed teachers`)
        update.remove.teachers = teachers.remove
      }
    }

    if (updateYearLevels) {
      const oldYearLevels = classExist.yearLevel || []
      const newYearLevels = incomingData.yearLevel || []
      if (JSON.stringify(oldYearLevels) !== JSON.stringify(newYearLevels)) {
        messages.push(`Updated year levels`)
        update.yearLevel = newYearLevels
      }
    }

    if (updateSubject) {
      const oldSubject = classExist.subjectId || ''
      const newSubject = incomingData.subjectId || ''
      if (JSON.stringify(oldSubject) !== JSON.stringify(newSubject)) {
        messages.push(`Updated subject`)
        update.subjectId = newSubject
      }
    }

    if (isEmpty(update)) {
      message = 'Class no changes to update'
    } else {
      message = `Class to be updated: ${messages.join(', ')}`
      color = 'info'
    }
  } else {
    message = 'Class to be created'
    color = 'success'
  }

  return { message, error, color }
}

const compareListSubjects = (currentData = [], incomingData = []) => {
  const codeWillBeCreated = incomingData.filter((incoming) => {
    const subjectExist = currentData.find((current) => current.code === incoming.code)
    return !subjectExist
  })
  let list = currentData.map((current) => {
    current.show = true
    const incoming = incomingData.find((item) => item.code === current.code)
    if (incoming) {
      current.message = 'found incoming'
    } else {
      current.message = 'Subject to be deleted'
    }

    return current
  })

  return list.concat(codeWillBeCreated)
}

const compareListSubject = (currentList, incomingData) => {
  let message = ''
  let error = false
  let color = 'default'
  let changes = {}

  const subjectExist = currentList.find((current) => current.code === incomingData.code)
  if (subjectExist) {
    if (incomingData.name !== subjectExist.name) {
      changes.name = incomingData.name
    }
    if (subjectExist.isDeleted) {
      changes.isDeleted = false
    }

    if (!isEmpty(changes)) {
      message = subjectExist.isDeleted ? 'Will be reactivated and updated' : 'Will be updated'
      color = 'info'
    } else {
      message = 'Has no changes to update'
      color = 'default'
    }
    // if (!error) {
    //   let subject = {};
    //   Object.keys(incomingData).forEach((key) => {
    //     if (incomingData[key]) {
    //       if (JSON.stringify(incomingData[key]) !== JSON.stringify(subjectExist[key])) {
    //         subject[key] = incomingData[key];
    //       }
    //     }
    //   });

    //   if (Object.keys(subject).length > 0) {
    //     message = 'Subject to be updated';
    //     color = 'info';
    //     changes = subject;
    //   } else {
    //     message = 'Subject no changes to update';
    //     color = 'default';
    //   }
    // }
  } else {
    message = 'Will be created'
    color = 'success'
  }

  return { message, error, color }
}

export { compareListUsers, compareListClasses, compareListSubject, compareListSubjects }
